import React from 'react';

export default function EmailSpacerBlock({ props, isSelected }) {
  return (
    <div style={{ height: props.height || '24px', position: 'relative' }}>
      {isSelected && (
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 border-t border-dashed border-stone-300" />
      )}
    </div>
  );
}
